import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { localize } from 'helpers/translator'
import tooltipTypes from 'helpers/enums/tooltipTypes'
import HintTooltip from 'components/tooltip/hint/hint_tooltip_container'

import firstLessonAsset from 'assets/components/tooltip/first_lesson.png'

import styles from './hint_tooltip_controller.scss'

class HintTooltipController extends PureComponent {

	buildRegularTooltip = () => (
		<div styleName='regular-tooltip'>
			<HintTooltip
				type='tooltipOBLiveSession'
				hintText={localize('lessons_list_npp_live_participation_session_tooltip')}
				hintButton={localize('lessons_list_npp_live_session_tooltip_button')}
			/>
		</div>
	)

	buildFirstLessonTooltip = () => (
		<div styleName='first-lesson-tooltip'>
			<HintTooltip
				arrowPosition='left-center'
				type='tooltipOBLiveSession'
				hintText={localize('firstLessonTooltip_liveLesson_text2')}
				headerImage={firstLessonAsset}
				centeredContent
				animatedContent={true}
				shouldShowButton={false}
			/>
		</div>
	)

	buildTooltip = () => {
		if (this.props.type === '') {
			return null
		}

		switch (this.props.type) {
			case tooltipTypes.REGULAR:
				return this.buildRegularTooltip()

			case tooltipTypes.FIRST_LESSON:
				return this.buildFirstLessonTooltip()

			case tooltipTypes.NONE:
			default:
				return null
		}
	}

	render() {
		return this.buildTooltip()
	}
}

HintTooltipController.propTypes = {
	type: PropTypes.string,
}

HintTooltipController.defaultProps = {
	type: '',
}

export default CSSModules(HintTooltipController, styles, {allowMultiple: true})
